document.getElementById('copy-button').addEventListener('click', function () {
        const discountCode = document.getElementById('discount-code').textContent;
        navigator.clipboard.writeText(discountCode).then(() => {
            // Change button color and show copied status
            this.style.backgroundColor = '#18aef2';
            this.textContent = 'Copied!';

            // Reset button after 2 seconds
            setTimeout(() => {
                this.style.backgroundColor = '#18aef2;';
                this.textContent = 'Copy Code';
                copyStatus.classList.add('hidden');
            }, 5000);
        }).catch(err => {
            console.error('Failed to copy discount code: ', err);
        });
});